/*
IMPORTANT RULES:
1. Emitter strings MUST be unique
2. Same emitter SHOULD NOT be caught (ie: $emitter.on("EMITTER_NAME")) in more than one place, CAN be fired from multiple places
*/

const ALL_EMITTERS = {
  //CreatePlan
  CONFIRM_ADD_GOAL_TASKS_TO_PLAN_CREATE_FORM: "confirmAddGoalTasksToPlanCreateForm",
  ADD_SELECTED_GOALS_TO_PLAN_CREATE_FORM: "addSelectedGoalsToPlanCreateForm",
  ADD_SELECTED_TASKS_TO_PLAN_CREATE_FORM: "addSelectedTasksToPlanCreateForm",
  GOAL_UPDATED_IN_PLAN_CREATE_FORM: "goalUpdatedInPlanCreateForm",
  TASK_UPDATED_IN_PLAN_CREATE_FORM: "taskUpdatedInPlanCreateForm",

  //EditPlan
  CONFIRM_ADD_GOAL_TASKS_TO_PLAN_UPDATE_FORM: "confirmAddGoalTasksToPlanUpdateForm",
  ADD_SELECTED_GOALS_TO_PLAN_UPDATE_FORM: "addSelectedGoalsToPlanUpdateForm",
  GOAL_UPDATED_IN_PLAN_UPDATE_FORM: "goalUpdatedInPlanUpdateForm",
  ADD_SELECTED_TASKS_TO_PLAN_UPDATE_FORM: "addSelectedTasksToPlanUpdateForm",
  TASK_UPDATED_IN_PLAN_UPDATE_FORM: "taskUpdatedInPlanUpdateForm",

  //NewGoalForm
  ADD_SELECTED_TASKS_TO_GOAL_CREATE_FORM: "addSelectedTasksToGoalCreateForm",
  TASK_UPDATED_IN_GOAL_CREATE_FORM: "taskUpdatedInGoalCreateForm",

  //NewInteractionForm
  ADD_SELECTED_TASKS_TO_INTERACTION_CREATE_FORM: "addSelectedTasksToInteractionCreateForm",
  TASK_UPDATED_IN_INTERACTION_CREATE_FORM: "taskUpdatedInInteractionCreateForm",

  //PlanEndUserView
  ADD_SELECTED_GOALS_TO_PLAN: "addSelectedGoalsToPlan",
  ADD_SELECTED_TASKS_TO_PLAN: "addSelectedTasksToPlan",

  //Add task/goal to milestone
  ADD_TASK_TO_MILESTONE_CREATE_FORM: "addTaskToMilestoneCreateForm",
  ADD_GOAL_TO_MILESTONE_CREATE_FORM: "addGoalToMilestoneCreateForm",

  //UpdateGoalForm
  ADD_SELECTED_TASKS_TO_GOAL_UPDATE_FORM: "addSelectedTasksToGoalUpdateForm",
  TASK_UPDATED_IN_GOAL_UPDATE_FORM: "taskUpdatedInGoalUpdateForm",

  //UpdateInteractionForm
  ADD_SELECTED_TASKS_TO_INTERACTION_UPDATE_FORM: "addSelectedTasksToInteractionUpdateForm",
  TASK_UPDATED_IN_INTERACTION_UPDATE_FORM: "taskUpdatedInInteractionUpdateForm",

  //ContactsListModal
  OPEN_EMAIL_CONTACTS_MODAL_FROM_SEND_EMAIL_FORM: "openEmailContactsModalFromSendEmailForm",
  OPEN_EMAIL_CONTACTS_MODAL_FROM_SEND_PLAYBOOKS: "openEmailContactsModalFromPlaybooks",

  RECORD_UPDATED: "recordUpdated",
  CURRENT_COMPANY_UPDATED: "currentCompanyUpdated",
  //ActionsAndInteractionsTable
  CURRENT_COMPANY_UPDATED_IN_ACTIONS_TABLE: "currentCompanyUpdatedInActionsTable",
  NEW_PLAN_ADDED: "newPlanAdded",
  PLAN_UPDATED: "planUpdated",
  NEW_GOAL_ADDED: "newGoalAdded",
  GOAL_UPDATED: "goalUpdated",
  NEW_TASK_ADDED: "newTaskAdded",
  TASK_UPDATED: "taskUpdated",
  NEW_INTERACTION_ADDED: "newInteractionAdded",
  INTERACTION_UPDATED: "interactionUpdated",
  PLAN_REMOVED: "planRemoved",
  GOAL_REMOVED: "goalRemoved",
  TASK_REMOVED: "taskRemoved",
  INTERACTION_REMOVED: "interactionRemoved",

  // whatsapp
  WHATSAPP_MESSAGE_REMOVED: "whatsappMessageRemoved",
  WHATSAPP_MESSAGE_RECEIVED: "whatsappMessageReceived",
  WHATSAPP_MESSAGE_STATUS_UPDATE: "whatsappMessageStatusUpdate",

  //Activities templates
  NEW_ACTIVITY_TEMPLATE_ADDED: "newActivityTemplateAdded",
  //AdvancedCompaniesMetricsTable
  PORTFOLIO_UPDATED_IN_ADVANCED_COMPANIES_METRICS_TABLE: "portfolioUpdatedInAdvancedCompaniesMetricsTable",
  RECORD_ADDED: "recordAdded",
  EXPORT_TABLE_TO_CSV: "exportTableToCSV",

  //CompanyOverviewCompanyDetails
  CURRENT_COMPANY_UPDATED_IN_OVERVIEW_COMPONENT: "currentCompanyUpadedInOverviewComponent",
  PORTFOLIO_UPDATED_IN_OVERVIEW_COMPONENT: "portfolioUpdatedInOverviewComponent",
  CUSTOM_METRIC_ADDED_IN_OVERVIEW_COMPONENT: "customMetricAddedInOverviewComponent",
  RECORD_UPDATED_IN_OVERVIEW_COMPONENT: "recordUpdatedInOverviewComponent",
  METRICS_CHANGED: "metricsChanged",
  METRIC_DELETED: "metricDeleted",

  //CustomerJourneysView
  INIT_PHASES_IN_CUSTOMER_JOURNEYS_VIEW: "initPhasesInCustomerJourneysView",
  UPDATE_JOURNEY_IN_CUSTOMER_JOURNEYS_VIEW: "updateJourneyInCustomerJourneysView",
  JOURNEY_DELETED_AND_DISTRIBUTION_DONE_IN_CUSTOMER_JOURENY_VIEW: "journeyDeletedAndDistributionDoneInCustomerJourneysView",
  PHASES_ADDED_TO_CUSTOMER_JOURNEYS_VIEW: "phaseAddedToCustomerJourneysView",
  PHASE_MODIFIED_IN_CUSTOMER_JOURNEYS_VIEW: "phaseModifiedInCustomerJourneysView",

  //DashboardForecastingTable
  UPDATE_FORECASTING: "updateForecasting",
  UPDATE_COUNT_NOTES_IN_DASHBOARD_FORECASTING_TABLE: "updateCountNotesInDashboardForecastingTable",
  UPDATE_COUNT_NOTES_IN_RECORDS_TABLE: "updateCountNotesInRecordsTable",
  REFRESH_FORECAST: "refreshForecast",
  DELETE_FORECAST: "deleteForecast",
  //not fired anywhere
  UPDATE_RECORD_IN_FORECASTING_TABLE: "updateRecordInForecastingTable",
  HIDE_COMPANIES_FROM_FORECAST: "hideCompaniesFromForecast",
  SHOW_HIDDEN_COMPANIES_FROM_FORECAST: "showHiddenCompaniesFromForecast",
  DELETE_COMPANIES_FROM_FORECAST: "deleteCompaniesFromForecast",

  //ExpansionLists
  DELETE_EXPANSION_LIST_IN_EXPANSION_LIST_COMPONENT: "deletedExpansionListInExpansionListComponent",
  GET_LIST_IN_EXPANSION_LIST_COMPONENT: "getListInExpansionListComponent",

  //GrowthMatrixView
  REMOVE_GROWTH_LIST_FROM_GROWTH_MATRIX_COMPONENT: "removeGrowthListFromGrowthMatrixComponent",
  GROWTH_MATRIX_CREATED_IN_GROWTH_MATRIX_COMPONENT: "growthMatrixCreatedInGrowthMatrixComponent",

  //KeyPeopleComponent
  UPDATE_KEY_RECORDS_TIED_RECORD: "updateKeyRecordsTiedRecord",

  //LastTouchComponent
  UPDATE_LAST_TOUCH_RECORD: "updateLastTouchTiedRecord",

  //MetricFieldInput
  LIST_METRICS_CHANGED: "listMetricsChanged",

  //OwnersListComponent
  RECORD_UPDATED_IN_OWNERS_LIST_COMPONENT: "recordUpdatedInOwnersListComponent",
  UPDATE_TIED_RECORD_IN_OWNERS_LIST_COMPONENT: "updateTiedRecordInOwnersListComponent",

  //PagesTabs
  PORTFOLIO_UPDATED_IN_TABS: "portfolioUpdatedInTabs",
  CONFIRM_DELETE_PAGE_IN_TABS: "confirmDeletePageInTabs",

  //RecordTitleComponent
  UPDATE_TITLE_TIED_RECORD: "updateTitleTiedRecord",

  //SuggestedListView
  REMOVE_SUGGESTED_LIST_IN_SUGGESTED_LIST_COMPONENT: "removeSuggestedListInSuggestedListComponent",
  SUGGESTED_LIST_CREATED_IN_SUGGESTED_LISTS_COMPONENT: "suggestedListCreatedInSuggestedListComponent",

  //ComponentList
  OPEN_INSTANCE_EDIT_FORM: "openInstanceEditForm",
  OPEN_INSTANCE_REPLACE_FORM: "openInstanceReplaceForm",
  COMPONENT_FORM_SUBMITTED: "componentFormSubmitted",

  //add-new-component
  EDIT_INSTANCE: "editInstance",
  REPLACE_INSTANCE: "replaceInstance",
  ADD_GRAPH_TO_COMPONENTS: "addGraphToComponents",
  GRAPH_DELETED_IN_ADD_NEW_COMPONENTS_MODAL: "graphDeletedInAddNewComponentsModal",
  GRAPH_DELETED_IN_LAYOUT: "graphDeletedInLayout",
  GRAPH_UPDATED_IN_ADD_NEW_COMPONENTS_MODAL: "graphUpdatedInAddNewComponentsModal",
  CANCEL_GRAPH_UPDATE: "cancelGraphUpdate",
  CANCEL_FLAT_INSTANCE_UPDATE: "cancelFlatInstanceUpdate",
  UPDATE_FLAT_INSTANCE: "updateFlatInstance",
  ADD_SCORE_TO_COMPONENTS_LIST: "addScoreToComponentsList",
  ADD_METRIC_TO_COMPONENTS_LIST: "addMetricToComponentsList",
  EDIT_IMAGE: "editImage",
  LAYOUT_UPDATED_IN_ADD_COMPONENTES_MODAL: "layoutUpdatedInAddComponentModal",
  IS_EDIT_MODE_ACIVE: "isEditModeActive",
  //not fired anywhere
  EDIT_TEXT: "editText",
  EDIT_NOTES: "editNotes",

  //Graph
  GRAPH_UPDATED: "graphUpdated",

  //GraphsGrid
  GRAPHS_SHOW_UPDATED: "graphsShowUpated",
  METRIC_UPDATED_IN_GRAPHS_GRID: "metricUpdatedInGraphsGrid",
  GRAPH_CREATED: "graphCreated",
  GRAPH_UPDATED_IN_GRAPHS_GRID: "graphUpdatedInGraphsGrid",
  GRAPH_DELETED_IN_GRAPHS_GRID: "graphDeletedInGraphsGrid",
  EDIT_GRAPH_IN_GRAPHS_GRID: "editGraphInGraphsGrid",

  //AddNewRecord
  //not fired anywhere
  NEW_FIELD_ADDED: "newFieldAdded",
  //not fired anywhere
  ADD_CONTAC_PLG: "addContactPlg",
  //not fired anywhere
  ADD_COMPANY_PLG: "addCompanyPlg",

  //MapPreview
  //not fired anywhere
  UPDATE_MAP: "updateMap",
  CURRENT_COMPANY_CHANGED_INSIDE_MAP: "currentCompanyChangedInsideMap",

  //UpdateRecord
  PORTFOLIO_UPDATED_IN_UPDATE_RECORD_FORM: "portfolioUpdatedInUpdateRecordForm",

  //ObjectsView
  PORTFOLIO_UPDATED_IN_OBJECTS_VIEW: "portfolioUpdatedInObjectsView",

  //ObjectView
  NEW_GROUP_CREATED_IN_OBJECT_VIEW: "newGroupCreatedInObjectView",

  SUCCESSFULLY_DELETED: "successfullyDeleted",
  METRICS_UPDATED_IN_OBJECT_VIEW: "metricUpdatedInObjectView",
  METRICS_ORDER_UPDATED_IN_TABLE: "metricOrderUpdatedInTable",
  //not fired anywhere
  REFRESH_TABLE: "refreshTable",
  BULK_DELETED: "bulkDeleted",
  RESET_INITIAL_RECORDS: "resetInitialRecords",

  //LayoutContainer
  FORCE_INIT_LAYOUT: "forceInitLayout",
  WORKSPACE_CHANGED: "workspaceChanged",
  LAYOUT_UPDATED: "layoutUpdated",
  REFRESH_ROLLUP_METRICS: "refetchRollupMetrics",
  REFRESH_STANDARD_METRICS: "refetchStandardMetrics",
  EDIT_LAYOUT: "editLayout",
  TOGGLE_EDIT_LAYOUT: "toggleEditLayout",
  TOGGLE_ADD_REMOVE_COMPONENT: "toggleAddRemoveComponent",
  DUPLICATE_PAGE: "duplicatePage",
  ADD_GRAPH_TO_LAYOUT: "addGraphToLayout",
  UPDATE_TEXT_INSTANCE: "updateTextInstance",
  UPDATE_ASSETS_INSTANCE: "updateAssetsInstance",
  UPDATE_NOTES_INSTANCE: "updateNotesInstance",
  REFETCH_ROLLUP_METRIC: "refetchRollupMetric",
  GROUP_UPDATED_IN_OBJECT_VIEW: "groupUpdatedInObjectView",
  PORTFOLIO_PAGES_TEMPLATE_CHANGED: "portfolioPagesTemplateChanged",
  ROLLUP_TRUNCATE_BY_CHANGE: "rollupTruncateByChange",

  //LayoutItemWrapper
  RECORD_UPDATED_IN_LAYOUT_ITEM_WRAPPER: "recordUpdatedInLayoutItemWrapper",
  HIGHLIGHT_DATASOURCE: "highlightDataSource",

  //ForecastingMetric
  REFRESH_FORECAST_METRIC: "refreshForecastMetric",
  REFRESH_FORECAST_TABLE_METRICS: "refreshForecastTableMetrics",

  //RollupMetric
  REFRESH_ROLLUP_METRIC: "refreshRollupMetric",

  //RollupMetricsGrid
  PORTFOLIO_UPDATED_IN_ROLLUP_METRICS_GRID: "portfolioUpdatedInRollupMetricsGrid",
  //not fired anywhere
  ROLLUP_METRICS_UPDATE: "rollupMetricsUpdate",

  //GenericNewRecordModal
  PORTFOLIO_UPDATED_IN_NEW_RECORD_FORM: "portfolioUpdatedInNewRecordForm",
  ADD_NEW_RECORD: "addNewRecord",

  //MainContainer
  JOURNEY_ADDED: "journeyAdded",
  //not fired
  UPDATED_JOURNEY_IN_SIDE_MENU: "updateJourneyinSideMenu",
  JOURNEY_DELTED: "journeyDeleted",

  //SideMenu
  PORTFOLIO_UPDATED_IN_SIDE_MENU: "portfolioUpdatedInSideMenu",
  CONFIRM_DELETE_PAGE: "confirmDeletePage",
  PAGES_DELETED_IN_SIDE_MENU: "pagesDeletedInSideMenu",

  //Container
  SPREADSHEET_IS_LOADED_IN_ADMIN_CONTAINER: "spreadsheetIsLoadedInAdminContainer",
  SUBMITTING_CSV_STARTED_IN_ADMIN_CONTAINER: "submittingCSVStartedInAdminContainer",
  SUBMITTING_CSV_ENDED_IN_ADMIN_CONTAINER: "submittingCSVEndedInAdminContainer",

  //Metrics
  RELOAD_METRICS_AND_SOURCES: "reloadMetricsAndSources",
  CUSTOM_METRIC_ADDED_IN_METRICS: "customMetricAddedInMetrics",

  //NewTeam
  SUBMIT_NEW_TEAM: "submitNewTeam",

  //Teams
  ADD_TEAM: "addTeam",
  REFRESH_TEAMS: "refreshTeams",
  GO_BACK: "goBack",

  //UpdateTeam
  UPDATE_TEAM: "updateTeam",

  //IntegrationsList
  CANCEL_CSV_UPLOAD: "cancelCSVUpload",

  //Salesforce
  STOP_SYNCING_SALESFORCE: "stopSyncingSalesforce",
  SELECT_MAPPING_OBJECT_SALESFORCE: "selectedMappingObjectSalesforce",
  START_SYNCING_SALESFORCE: "startSyncingSalesforce",
  SELECT_OTHER_OBJECT_SALESFORCE: "selectOtherObjectSalesforce",
  FINISH_STEP_SALESFORCE: "finishStepSalesforce",
  OBJECT_CHECKED_SALESFORCE: "objectCheckedSalesforce",
  // NOTE:DON'T DELETE fired by realtime sync
  UPDATE_SYNCING_SALESFORCE: "updateSyncingSalesforce",

  //Hupspot
  STOP_SYNCING_HUBSPOT: "stopSyncingHubspot",
  SELECT_MAPPING_OBJECT_HUBSPOT: "selectedMappingObjectHubspot",
  START_SYNCING_HUBSPOT: "startSyncingHubspot",
  SELECT_OTHER_OBJECT_HUBSPOT: "selectOtherObjectHubspot",
  FINISH_STEP_HUBSPOT: "finishStepHubspot",
  OBJECT_CHECKED_HUBSPOT: "objectCheckedHubspot",
  // NOTE:DON'T DELETE fired by realtime sync
  UPDATE_SYNCING_HUBSPOT: "updateSyncingHubspot",

  //Postgres
  STOP_SYNCING_POSTGRES: "stopSyncingPostgres",
  SELECT_MAPPING_OBJECT_POSTGRES: "selectedMappingObjectPostgres",
  START_SYNCING_POSTGRES: "startSyncingPostgres",
  SELECT_OTHER_OBJECT_POSTGRES: "selectOtherObjectPostgres",
  FINISH_STEP_POSTGRES: "finishStepPostgres",
  OBJECT_CHECKED_POSTGRES: "objectCheckedPostgres",
  // NOTE:DON'T DELETE fired by realtime sync
  UPDATE_SYNCING_POSTGRES: "updateSyncingPostgres",

  //Postgres
  STOP_SYNCING_MYSQL: "stopSyncingMySQL",
  SELECT_MAPPING_OBJECT_MYSQL: "selectedMappingObjectMySQL",
  START_SYNCING_MYSQL: "startSyncingMySQL",
  SELECT_OTHER_OBJECT_MYSQL: "selectOtherObjectMySQL",
  FINISH_STEP_MYSQL: "finishStepMySQL",
  OBJECT_CHECKED_MYSQL: "objectCheckedMySQL",
  // NOTE:DON'T DELETE fired by realtime sync
  UPDATE_SYNCING_MYSQL: "updateSyncingMySQL",

  //Data based
  STOP_SYNCING: "stopSyncing",
  SELECT_MAPPING_OBJECT: "selectedMappingObject",
  START_SYNCING: "startSyncing",
  SELECT_OTHER_OBJECT: "selectOtherObject",
  FINISH_STEP: "finishStep",
  OBJECT_CHECKED: "objectChecked",
  // NOTE:DON'T DELETE fired by realtime sync
  UPDATE_SYNCING: "updateSyncing",

  //ExpressionHolder
  //not fired anywhere
  ADD_ELEMENT_TO_FORMULARY: "addElementToFormulary",
  //not fired anywhere
  DRAG_IS_ON_IN_EXPRESSION_HOLDER: "dragIsOnInExpressionHolder",

  //FormulaHolder
  //not fired anywhere
  DRAG_IN_ON_FORMULAT_HOLDER: "dragIsOnInFormulaHolder",

  //ImportSpreadSheet
  OBJECT_TYPE_NAME: "objectTypeName",
  SUBMIT_MAPPING: "submitMapping",
  SYNC_SHEET_UPDATED: "syncSheetUpdated",

  //LeadsTable
  EXPORT_LEADS_TABLE_CSV: "exportLeadsTableToCSV",
  RESET_NEW_LEADS_TABLE: "resetNewLeadsTable",
  //not fired anywhere
  NEW_LEAD: "newLead",

  //index - CalendarView
  DARK_MODE_CHANGED: "darkModeChanged",
  //not fired anywhere
  INTERACTION_UPDATED_IN_CALENDAR: "interactionUpdatedInCalendar",
  NEW_MEETING_CREATED: "newMeetingCreated",
  NEW_ACTINON_CREATED_OR_UPDATED: "newActionCreatedOrUpdated",
  ACTION_DELETED: "actionDeleted",

  //Analysis
  ANALYSIS_VIEW_UPDATED: "analysisViewUpdated",
  TOGGLE_ANALYSIS_VIEW: "toggleAnalysisView",

  //Journeys
  INIT_PHASES_IN_JOURNEYS: "initPhasesInJourneys",
  CURRENT_JOURNEY_CHANGED: "currentJourneyChanged",
  //not fired anywhere
  UPDATE_JOURNEY_IN_JOURNEYS: "updateJourneyInJourneys",
  JOURNEY_DELETED_AND_DISTRIBUTION_DONE_IN_JOURNEYS: "journeyDeletedAndDistributionDoneInJourneys",
  PHASES_ADDED_TO_JOURNEYS: "phaseAddedToJourneys",
  PHASE_MODIFIED_IN_JOURNEYS: "phaseModifiedInJourneys",

  //AnalysisMainEdit
  SAVE_ANALYSIS_VIEW: "saveAnalysisView",

  //ExpansionLists
  DELETE_EXPANSION_LIST_IN_STATIC_EXPANSION_LIST: "deletedExpansionListInStaticExpansionList",
  GET_LIST_IN_STATIC_EXPANSION_LIST: "getListInStaticExpansionList",

  //MyCompanies
  //not fired anywhere
  DELTEE_PROSPECTING_SEARCH: "deleteProspectingSearch",

  //SuggestedCompanies
  REMOVE_SUGGESTED_LIST_IN_PROSPECTING_COMPONENT: "removeSuggestedListInProspectingComponent",
  SUGGESTED_LIST_CREATED_IN_PROSPECTING_COMPONENT: "suggestedListCreatedInProspectingComponent",
  SUGGESTED_LIST_UPDATED_IN_PROSPECTING_COMPONENT: "suggestedListUpdatedInProspectingComponent",

  //SwotView
  REMOVE_GROWTH_LIST_FROM_SWOT_VIEW: "removeGrowthListFromSwotView",
  GROWHT_MATRIX_CREATED_IN_SWOT_VIEW: "growthMatrixCreatedInSwotView",

  //Playbooks
  CREATE_NEW_PLAYBOOK: "createNewPlaybook",
  PLAYBOOK_TO_BE_CREATED: "playbookToBeCreated",
  PLAYBOOK_EDITED: "playbookEdited",
  DELETE_A_PLAYBOOK: "deleteAPlaybook",
  NEW_PLAYBOOK_ADDED: "newPlaybookAdded",
  PLAYBOOK_REMOVED: "playbookRemoved",
  PLAYBOOK_UPDATED: "playbookUpdated",

  //NewInteraction
  //not fired anywhere
  ADD_TAG: "addTag",

  //NewPlanForm
  //not fired anywhere
  TASK_CREATED: "taskCreated",
  //not fired anywhere
  GOAL_CREATED: "goalCreated",

  //Churn
  //not fired anywhere
  CHRUN_VIEW_UPDATED: "churnViewUpdated",
  TOGGLE_CHURN_VIEW: "toggleChurnView",

  //Revenue
  //not fired anywhere
  REVENUE_VIEW_UPDATED: "revenueViewUpdated",
  TOGGLE_REVENUE_VIEW: "toggleRevenueView",

  //Trends
  TRENDS_VIEW_UPDATED: "trendsViewUpdated",
  TOGGLE_TRENDS_VIEW: "toggleTrendsView",

  //ChurnMainEdit
  SAVE_CHURN_VIEW: "saveChurnView",

  //RevenueMainEdit
  SAVE_REVENUE_VIEW: "saveRevenueView",

  //ObjectForecast
  UPDATE_FORECAST: "updateForecast",
  UPDATE_COUNT_NOTES_IN_OBJECT_FORECAST: "updateCountNotesInObjectForecast",
  //not fired anywhere
  PROFILE_UPDATED: "profileUpdated",

  //TrendsMainEdit
  SAVE_TRENDS_VIEW: "saveTrendsView",

  //SuggestedLists
  REMOVE_SUGGESTED_LIST_IN_ADMIN_SETTINGS: "removeSuggestedListInAdminSettings",

  //AllCustomers
  SPREAD_SHEET_IS_LOADED_IN_ONBOARDING_CONTAINER: "spreadsheetIsLoadedInOnboardingContainer",
  SUBMITTING_CSV_STARTED_IN_ONBOARDING_CONTAINER: "submittingCSVStartedInOnboardingContainer",
  SUBMITTING_CSV_EDED_IN_ONBOARDING_CONTAINER: "submittingCSVEndedInOnboardingContainer",
  ONBOARDING_FINISH_LINKING_SALESFORCE: "onboarding-finish-linking-salesforce",
  ONBOARDING_FINISH_LINKING_HUBSPOT: "onboarding-finish-linking-hubspot",

  //ImportCustomers
  ONBOARDING_BACK_SLACK_IN_IMPORT_CUSTOMERS: "onboarding-back-slack-in-import-customers",
  ONBOARDING_BACK: "onboarding-back",

  //InviteTeamMembers
  ONBOARDING_FINISH_INVITE_TEAM_MEMBERS: "onboarding-finish-invite-team-members",

  SELECTED_USERS: "selectedUsers",

  //SidebarOnboarding
  ONBOARDING_IMPORT_CUSTOMERS: "onboarding-import-customers",
  ONBOARDING_CONNECT_YOUR_TOOLS: "onboarding-connect-your-tools",
  ONBOARDING_INVITE_YOUR_TEAM: "onboarding-invite-your-team",

  //StartWithKeyAccounts
  ONBOARDING_BACK_SLACK_IN_KEY_ACCOUNT: "onboarding-back-slack-in-key-account",
  ONBOARDING_FINISH_KEY_ACCOUNTS: "onboarding-finish-key-accounts",

  //WorkspaceVisiblePages
  WORKSPACE_UPDATED_IN_PAGES: "workspaceUpdatedInPages",

  //index - workspacesList
  WORKSPACE_ORGANIZATION_CHANGED: "workspaceOrganizationChanged",

  ORGANIZATION_CHANGED: "organizationChanged",

  //workspaceItemCard
  CONFIRM_DELETE_WORKSPACES: "confirmDeleteWorkspaces",

  //Modals
  //not fired anywhere
  PROFILE_UPDATED_IN_MODALS: "profileUpdatedInModals",
  EDIT_KEY_RECORDS: "editKeyRecords",
  EMPTY_KEY_RECORDS: "emptyKeyRecords",
  CHANGE_WORKSPACE_ORGANIZATION: "changeWorkspaceOrganization",
  CHANGE_ORGANIZATION: "changeOrganization",
  REMOVE_WORKSPACE_PAGE: "removeWorkspacePage",
  REMOVE_WORKSPACE_TEAM_MEMBER: "removeWorkspaceTeamMember",
  REMOVE_WORKSPACE_CONTACT: "removeWorkspaceContact",
  DELETE_WORKSPACES: "deleteWorkspaces",
  CREATE_NEW_WORKSPACE: "createNewWorkspace",
  ADD_NEW_WORKSPACE_TEAM_COLLABORATOR: "addNewWorkspaceTeamCollaborator",
  ADD_NEW_WORKSPACE_CONTACT_COLLABORATOR: "addNewWorkspaceContactCollaborator",
  ADD_GOAL_TASKS_TO_PLAN: "addGoalTasksToPlan",
  DELETE_PAGE: "deletePage",
  INVITE_TEAM_MEMBERS: "inviteTeamMembers",
  DELETE_GRAPH: "deleteGraph",
  EDIT_GRAPH: "editGraph",
  CREATE_GRAPH: "createGraph",
  ADD_NEW_COMPONENT: "addNewComponent",
  CURRENT_TEMPLATE_UPDATED: "currentTemplateUpdated",
  SCORE_CREATED_FOR_MODAL: "scoreCreatedForModal",
  METRIC_CREATED_FOR_MODAL: "metricCreatedForModal",
  CLOSE_ADD_NEW_COMPONENT: "closeAddNewComponent",
  CREATE_CUSTOM_METRIC: "createCustomMetric",
  UPDATE_TABS: "updateTabs",
  UPDATE_FORECAST_TABLE_METRICS: "updateForecastTableMetrics",
  UPDATE_LEADS_TABLE_METRICS: "updateLeadsTableMetrics",
  UPDATE_ACTIVITIES_TABLE_HEADERS: "updateActivitiesTableHeaders",
  ADD_NOTES_FORECAST: "addNotesForecast",
  ADD_NOTES_RECORD: "addNotesRecord",
  NEW_NOTE_ADDED: "newNoteAdded",
  NOTE_EDITED: "noteEdited",
  NOTE_DELETED: "noteDeleted",
  UPDATE_METRICS: "updateMetrics",
  UPDATE_ROLLUP_METRICS: "updateRollupMetrics",
  SHOW_HIDE_GRAPHS: "showHideGraphs",
  GENERATE_EXTERNAL_SCORE: "generateExternalScore",
  CREATE_INTERACTION: "createNewInteraction",
  UPDATE_INTERACTION: "updateInteraction",
  //not fired anywhere
  DELETE_INTERACTION: "deleteInteraction",
  UPDATE_TASK: "updateTask",
  //not fired anywhere
  DELETE_TASK: "deleteTask",

  UPDATE_GOAL: "updateGoal",
  //not fired anywhere
  DELETE_GOAL: "deleteGoal",
  UPDATE_PLAN: "updatePlan",
  //not fired anywhere
  DELETE_PLAN: "deletePlan",
  CREATE_GROUP: "createGroup",
  DELETE_GROUP: "deleteGroup",
  DELETE_TEMPLATE: "deleteTemplate",
  TEMPLATE_DELETED: "templateDeleted",
  TEMPLATE_UPDATED: "templateUpdated",
  //not fired anywhere
  ADD_OBJECT_RECORD: "addObjectRecord",
  //not fired anywhere
  EDIT_GROUP: "editGroup",
  CREATE_GOAL: "createGoal",
  CREATE_TASK: "createTask",
  CREATE_PLAN: "createPlan",
  CREATE_OWNER: "createOwner",
  CREATE_NEW_GROUP: "createNewGroup",
  ASSIGN_TAGS: "assignTags",
  CHANGE_CO_OWNERS: "changeCoOwners",
  ADD_TO_EXPANSION_LIST: "addToExpansionList",
  SELECTED_EXPANSION_LIST: "selectedExpansionList",
  REMOVE_FROM_EXPANSION_LIST: "removeFromExpansionList",
  DELETE_EXPANSION_LIST: "deleteExpansionList",
  //not fired anywhere
  ADD_COMPANY: "addCompany",
  //not fired anywhere
  PROFILE_SUCCESS_CASE: "profileSuccessCase",
  REMOVE_SEARCH_ITEM: "removeSearchItem",
  //not fired anywhere
  COLORS_CHANGED: "colorsChanged",
  //not fired anywhere
  EDIT_METRIC: "editMetric",
  DELETE_PHASE: "deletePhase",
  EDIT_CUSTOM_METRIC: "editCustomMetric",
  EDIT_COMPUTED_METRIC: "editComputedMetric",
  //not fired anywehre
  EDIT_LIST_METRIC: "editListMetric",
  EDIT_NOTE: "editNote",
  DELETE_SELECTED_RECORDS: "deleteSelectedRecords",
  MODULE_IS_NOT_ACTIVATED: "moduleIsNotActivated",
  BULK_RECORDS_METRIC_UPDATE: "bulkRecordsMetricUpdate",
  MERGE_RECORDS_METRICS: "mergeRecordsMetrics",

  ADD_NEW_JOURNEY: "addNewJourney",
  EDIT_JOURNEY: "editJourney",
  DELETE_JOURNEY: "deleteJourney",
  //not fired anywhere
  DELETE_COLOR: "deleteColor",
  GRAPH_DETAIL_MODAL: "graphDetailModal",
  NESTED_METRIC_DETAIL_MODAL: "nestedMetricDetailModal",
  SEND_EMAIL: "sendEmail",
  SHOW_COMPETITOR_INSIGHTS: "showCompetitorInsights",
  //not fired anywhere
  EXPAND_PLAN: "expandPlan",
  //not fired anywhere
  COLLAPSE_PLAN: "collapsePlan",
  CREATE_NEW_PHASE: "createNewPhase",

  EDIT_PHASE: "editPhase",
  //not fired anywhere
  SHOW_SUCCESS_MODAL: "showSuccessModal",
  OPEN_TEAM_CHAT: "openTeamChat",
  MOVE_EMAIL_TO_TRASH: "moveEmailToTrash",
  RESTORE_EMAIL_FROM_TRASH: "restoreEmailFromTrash",
  DELETE_OBJECT: "deleteObject",
  INTEGRATION_MISSING_MODAL: "integrationMissingModal",
  SHARE_OBJECT: "shareObject",
  SHARE_PAGE: "sharePage",
  CLONE_PAGE: "clonePage",
  OPEN_PAGE_SETTINGS: "openPageSettings",
  MAP_CUSTOM_FIELDS: "mapCustomFields",
  ADD_NEW_RECORD_MODAL: "addNewRecordModal",
  ADD_NEW_TEMPLATE_MODAL: "addNewTemplateModal",
  SETUP_FORECASTING_MODAL: "setupForecastingModal",
  FIND_LEADS_LOCKED_MODAL: "findLeadsLockedModal",
  SHARE_ACTIVITY: "shareActivity",
  INVITE_TEAMMATES: "inviteTeammates",
  CREATE_A_SURVEY: "createASurvey",
  SELECT_A_SURVEY: "selectASurvey",
  SEND_A_SURVEY: "sendASurvey",
  SURVEY_RESPONSES: "surveyResponses",
  //SelectGroupDropdown
  GROUP_UPDATED_IN_GROUP_DROPDOWN: "groupUpdatedInGroupDropdown",

  GENERIC_DELETE_MODAL: "genericDeleteModal",
  //AI
  GOAL_UPDATED_IN_AI_PROMPT: "goalUpdatedInAIPrompt",
  TASK_UPDATED_IN_AI_PROMPT: "taskUpdatedInAIPrompt",
  PLAN_UPDATED_IN_AI_PROMPT: "planUpdatedInAIPrompt",
  INTERACTION_UPDATED_IN_AI_PROMPT: "interactionUpdatedInAIPrompt",
  //SurveySelectionForm
  SURVEY_CREATED_INSIDE_SURVEY_SELECTION_FORM: "surveyCreatedInsideSurveySelectionForm",
  SURVEY_CREATED_INSIDE_SURVEYS_LIST: "surveyCreatedInsideSurveysList",

  GET_INSIGHTS: "getInsights",
  CLICKFORMULAITEM: "clickFormulaItem",
  BACKSPACECLICKFORMULA: "backSpaceClickFormula",
  KEYCLICKFORMULA: "keyClickFormula",
  TRIGGER_FORMULA_CLICK: "triggerFormulaClick",
  SHOW_DROPDOWN_ACTIVE: "showDropdownActive",
  CLEAR_ACTIVE_FORMULA_ITEM: "clearActiveFormulaItem",
  FEEDBACK_FORM: "feedbackForm",

  UPDATE_BULK_DELETE_ACTION_STATUS: "updateBulkDeleteActionStatus",
  UPDATE_PLAYBOOK_EXECUTION_STEP: "updatePlaybookExecutionStep"
}

export { ALL_EMITTERS }
